import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { BounceLoader } from "react-spinners";
import { COLORS } from "../../../shared_modules/common/base/lc-constants";

const Icon = ({ type, classes }) => {
  let spinnerContainerClasses, spinnerCss, iconClasses;
  const {
    baseClass,
    alertClass,
    errorClass,
    successClass,
    privsecClass,
    spinnerClass,
    optClasses,
  } = classes;

  // spinner icon
  if (type === "spinner") {
    spinnerContainerClasses = classnames({
      [baseClass]: true,
      [spinnerClass]: true,
    });
    spinnerCss = {
      display: "block",
      margin: "1px",
      borderColor: `${COLORS.LCSkyBlue}`,
    };

    return (
      <div className={spinnerContainerClasses}>
        <BounceLoader
          cssOverride={spinnerCss}
          size={20}
          color={COLORS.LCTrueBlue}
          loading={true}
        />
      </div>
    );
  }

  // default icons
  iconClasses = classnames({
    [baseClass]: true,
    [alertClass]: type === "alert",
    [errorClass]: type === "error",
    [successClass]: type === "success",
    [privsecClass]: type === "privsec",
    [optClasses]: optClasses && optClasses.length > 0,
  });

  return <i className={iconClasses} aria-hidden="true" />;
};

Icon.defaultProps = {
  type: "icon",
  classes: {
    baseClass: "icon",
    alertClass: "icon-alert",
    errorClass: "icon-error",
    successClass: "icon-success",
    privsecClass: "icon-privacy-security",
    spinnerClass: "icon-spinner",
  },
};

Icon.propTypes = {
  type: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
};

export default Icon;

